<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
        {{ "save_page" | translate }}
    </h4>
</div>
<div class="modal-body">
    <div class="form-group mb-20" [class.has-error]="(name.invalid && name.touched) || nameAlreadyUsedError">
        <label class="control-label">
            {{ "site_name" | translate }}
        </label>

        <input type="text" class="form-control" [formControl]="name" />

        @if (name.errors && !name.valid && name.touched) {
            @if (name.errors.minlength) {
                <p class="help-block small">
                    {{ "control_errors_length" | translate: { MIN_LENGTH: NAME_MIN_LENGTH } }}
                </p>
            }
            @if (name.errors.required) {
                <p class="help-block small">
                    {{ "control_errors_required" | translate }}
                </p>
            }
        }

        @if (nameAlreadyUsedError) {
            <p class="help-block small">
                {{ "site_name_taken" | translate }}
            </p>
        }
    </div>

    <div class="form-group mb-20" [class.has-error]="(subDomain.invalid && subDomain.touched) || subDomainHasError">
        <label class="control-label">
            {{ "control_url" | translate }}
        </label>

        <div class="input-group">
            <div class="input-group-addon">https://</div>

            <input
                type="text"
                class="form-control"
                [class.disabled]="systemDomainsQuery.isLoading()"
                [formControl]="subDomain"
                spSubDomainCheck
                [spSubDomainOptions]="{ siteId, checkIfDirty: true }"
            />

            <div class="input-group-btn" dropdown>
                <button
                    class="btn btn-info dropdown-toggle"
                    [class.btn-loading]="systemDomainsQuery.isPending()"
                    [disabled]="form.disabled"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    dropdownToggle
                >
                    .{{ domain.value?.name }}
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu" *dropdownMenu>
                    @for (systemDomain of filteredSystemDomains(); track systemDomain) {
                        <li
                            [class.active]="systemDomain.id === domain.value?.id"
                            (click)="selectSystemDomain(systemDomain)"
                        >
                            <a>{{ systemDomain.name }}</a>
                        </li>
                    }
                </ul>
            </div>
        </div>
        @if (subDomainAlreadyExistsError) {
            <p class="help-block small">
                {{ "site_domain_taken" | translate }}
            </p>
        }

        @if (subDomainInvalidError) {
            <p class="help-block small">
                {{ "site_domain_invalid" | translate }}
            </p>
        }
    </div>

    @if (isUserTariffFree$ | async) {
        <div class="alert alert-paid has-paid-badge has-top-arrow">
            <span class="badge badge-paid">&nbsp;</span>
            {{ "get_unique_domain_alert_text" | translate }}
            <a href="https://login.sendpulse.com/landing-pages/plans" target="_blank"
                >{{ "get_pro_tariff_link" | translate }} <span class="sp-icon icon-outgoing small-xs color-light"></span
            ></a>
        </div>
    }
</div>

<div class="modal-footer">
    <button type="button" [disabled]="form.disabled" class="btn btn-link text-muted float-left" (click)="onCancel()">
        {{ "cancel" | translate }}
    </button>

    <button
        type="button"
        [disabled]="form.invalid || form.disabled || saveErrorCode || systemDomainsQuery.isPending()"
        class="btn btn-success btn-lg"
        (click)="onConfirm()"
    >
        {{ "publish" | translate }}
    </button>
</div>
